module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images/gabby-schwartz-a51d34d05c71f5dc1a739c079520ec9e.jpg";